const navigateTo = uni.navigateTo
const redirectTo = uni.redirectTo
const reLaunch = uni.reLaunch
const switchTab = uni.switchTab
const navigateBack = uni.navigateBack
uni.navigateTo = navigateTo
uni.redirectTo = redirectTo
uni.reLaunch = reLaunch
uni.switchTab = switchTab
uni.navigateBack = navigateBack
;
/*
 * @FilePath: \uni-preset-vue-vite\src\main.js
 * @Date: 2022-10-01 21:03:09
 * @Author: itmanyong@gmail.com
 * @LastEditors: guoye
 * @LastEditTime: 2024-12-03 16:33:35
 * @Description:
 */
import uviewPlus from 'uview-plus'
// #ifdef H5
import VConsole from 'vconsole'
import routeTransition from './js_sdk/route-transition'
import { fixArray } from './js_sdk/route-transition/fixArray'
fixArray('all')
// #endif
import { createSSRApp } from 'vue'
import App from './App.vue'
// import _ from 'lodash'
import 'uno.css'
// import 'virtual:uno.css'

console.error(16, '17-->', 17)

const plugins = Object.assign({}, ...Object.values(import.meta.globEager(`/src/plugins/*.[tj]s`)))
// console.log(17, 'plugins-->', plugins)

// 判断是否是pc设备
const isPc = () => {
  const userAgentInfo = navigator.userAgent
  const Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod']
  let flag = true
  for (let v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false
      break
    }
  }
  return flag
}

// #ifdef H5
const env = import.meta.env
// alert(JSON.stringify(env))
console.log(env)

//如果不是生产环境并且不是pc设备那么就显示调试
let params = util_urlToObj(location.href)
// console.log(52, 'params-->>>', params)
// alert(JSON.stringify(params))
if (!isPc()) {
  if (params.showVConsole == 'Y') {
    new VConsole()
  } else {
    if (env.VITE_VC == 'Y') {
      new VConsole()
    }
  }
}
// #endif

function createApp() {
  const app = createSSRApp(App)

  app.use(uviewPlus)
  app.use(routeTransition)
  // app.config.globalProperties.lodash = _

  for (let key in plugins) {
    plugins[key](app)
  }

  return {
    app,
  }
}

export { createApp }
